import { render, staticRenderFns } from "./sonOrder.vue?vue&type=template&id=ffa0af30&scoped=true"
import script from "./sonOrder.vue?vue&type=script&lang=js"
export * from "./sonOrder.vue?vue&type=script&lang=js"
import style0 from "./sonOrder.vue?vue&type=style&index=0&id=ffa0af30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa0af30",
  null
  
)

export default component.exports